import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "./controlInput";

export interface ControlHiddenProps extends ControlTemplateProps {

}

export const ControlHidden: React.FC<ControlHiddenProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ??  useControlStyles();
    
    return (
        <ControlInput type="hidden" {...ComponentProps(props)} style={{ ...props.style }} />        
    );
};